import React from "react";
import { NavLink } from "react-router-dom";

import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";

import "./Home.css";
import { GoogleApiWrapper } from "google-maps-react";

class Home extends React.Component {
  state = {
    address: "",
  };

  handleChange = (address) => {
    this.setState({ address });
  };

  handleSelect = (address) => {
    this.setState({
      address,
    });
    geocodeByAddress(address)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        console.log("Success", latLng);
        this.props.setCoordinates(latLng);
      })
      .catch((error) => console.error("Error", error));
  };

  render() {
    return (
      <main className="box">
              <div className="backMenuBoxHide">
          <NavLink to="/map">
            <img src="/images/back.png" />
          </NavLink>
          <h1>Your Appointments</h1>
        </div>
      <section className="homeBox">
      

        <img src="/images/logo.png" />
        
        <article className="homeCurve">
          <div className="test">
            <PlacesAutocomplete
            
              value={this.state.address}
              onChange={this.handleChange}
              onSelect={this.handleSelect}
            >
              {({
                getInputProps,
                suggestions,
                getSuggestionItemProps,
                loading,
              }) => (
                <div>
                  <input
                    {...getInputProps({
                      placeholder: "Search...",
                      className: "location-search-input",
                    })}
                  />
                  <div className="autocomplete-dropdown-container">
                    {loading && <div>Loading...</div>}
                    {suggestions.map((suggestion, index) => {
                      const className = suggestion.active
                        ? "suggestion-item--active"
                        : "suggestion-item";
                      // inline style for demonstration purpose
                      const style = suggestion.active
                        ? { backgroundColor: "#fafafa", cursor: "pointer" }
                        : { backgroundColor: "#ffffff", cursor: "pointer" };
                      return (
                        <div
                          key={index}
                          {...getSuggestionItemProps(suggestion, {
                            className,
                            style,
                          })}
                        >
                          <span>{suggestion.description}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </PlacesAutocomplete>
          </div>

          <div>
            <NavLink exact to="/map">
              <button className="findCarButton">GO</button>
            </NavLink>
          </div>
        </article>
      </section>
      </main>
    );
  }
}

export default Home;
